import React, { Component } from 'react';
import { connect } from 'react-redux';

import { fetchEvents, fetchPastEvents, fetchFeature, fetchEventContactBoxes } from '../actions';
import EventMagazineView from './event-magazine-view';
import EventListView from './events-list-view';
import EventPastListView from './event-past-list-view';
import EventPastMagazineView from './event-past-magazine-view';
import EventFeature from './event-feature';
import EventSearchArea from './search-events';
import EventSelectorFeatured from './event-selector-featured';
import './print-preview-events-agenda';
import { Global_ISDA_Functions } from 'Root/global/global';
import BlueHero from 'Root/archive-search/components/page-top/blue-hero';

class EventArchive extends Component {
	constructor() {
		super();
		this.state = {
			view: 'magazine', tab: 'ongoing'
		};
	}

	componentWillMount() {
		this.props.fetchEvents();
		this.props.fetchPastEvents();
		this.props.fetchFeature();
		this.props.fetchEventContactBoxes();
	}

	componentDidMount() {
		let reactWrapper = document.querySelector( '.react-fallback' );

		this.addWrapperClass( reactWrapper );
	}

	addWrapperClass( wrapper ) {
		let globalIsdaFunctions = new Global_ISDA_Functions();

		globalIsdaFunctions.vanillaAddClass( wrapper, 'visible' );
		globalIsdaFunctions.vanillaAddClass( wrapper, 'loaded' );
	}

	handleToggleTab( el ) {
		this.setState( {
			               tab: el.currentTarget.getAttribute( 'data-events-current' )
		               } );

		this.setActiveButton( el.currentTarget );
	}

	setActiveButton( el ) {
		let globalIsdaFunctions = new Global_ISDA_Functions();

		//add active class
		globalIsdaFunctions.vanillaAddClass( el, 'active' );

		//remove class from sibling button
		if ( el.nextElementSibling ) {
			globalIsdaFunctions.vanillaRemoveClass( el.nextElementSibling, 'active' );
		}

		if ( el.previousElementSibling ) {
			globalIsdaFunctions.vanillaRemoveClass( el.previousElementSibling, 'active' );
		}
	}

	renderEventsView() {
		if ( this.state.tab === 'ongoing' ) {
			return (<div className="events-posts-list magazine">
					<div id="events-magazine" className="custom-tab-wrapper"
					     role="tabpanel">
						<EventMagazineView/>
					</div>
				</div>
			);
		} else {
			return (<div className="events-posts-list magazine">
					<div id="events-magazine" className="custom-tab-wrapper"
					     role="tabpanel">
						<EventPastMagazineView/>
					</div>
				</div>
			);
		}
	};

	render() {
		return (<div id="EventsReactElement">
				<section className="container">
					<BlueHero
						featured={ [this.props.features] }
						isEvent={ true }
					/>
				</section>
				<section className="events-list-section">
					<div className="container">
						<h2 className="section-title__heading-gold">
							<span>All Events</span>
						</h2>
						<div className="section-title__divider"></div>
						<EventSearchArea/>
						<div className="sorting-bar no-border"
						     id="events-sorting-bar">
							<ul className="nav nav-tabs">
								<li name="Upcoming Events"
								    data-events-current="ongoing"
								    className="active" role="tab"
								    onClick={ this.handleToggleTab.bind( this ) }>Upcoming
									Events
								</li>
								<li name="Past Events"
								    data-events-current="expired" className=""
								    role="tab"
								    onClick={ this.handleToggleTab.bind( this ) }>Past
									Events
								</li>
							</ul>
						</div>
						{ this.renderEventsView() }
					</div>
				</section>
				<section className="events-sponsors">
					<div className="container">
						<div className="events-sponsors-list">
							{this.props.eventContactBoxes && this.props.eventContactBoxes.length > 0 && (
								this.props.eventContactBoxes.map((box, index) => (
									<div key={index}>
										<a href={box.link}>
											<img
												className="alignnone wp-image-1063807 size-full"
												src={box.image_url}
												alt=""
												width="550"
												height="550"
											/>
										</a>
									</div>
								))
							)}
						</div>
					</div>
				</section>
			</div>
		);
	}
}

function mapStateToProps( { features, eventContactBoxes } ) {
	return { features, eventContactBoxes };
}

export default connect( mapStateToProps, {
	fetchEvents, fetchPastEvents, fetchFeature, fetchEventContactBoxes
} )( EventArchive );